"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactForm = void 0;
const react_1 = __importStar(require("react"));
const card_1 = require("@authlance/ui/lib/browser/components/card");
const label_1 = require("@authlance/ui/lib/browser/components/label");
const input_1 = require("@authlance/ui/lib/browser/components/input");
const textarea_1 = require("@authlance/ui/lib/browser/components/textarea");
const button_1 = require("@authlance/ui/lib/browser/components/button");
const badge_1 = require("@authlance/ui/lib/browser/components/badge");
const lucide_react_1 = require("lucide-react");
const runtime_config_1 = require("@authlance/core/lib/browser/runtime-config");
const TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let turnstileScriptPromise = null;
const loadTurnstileScript = () => {
    if (typeof window === 'undefined') {
        return Promise.reject(new Error('window is not available'));
    }
    if (window.turnstile) {
        return Promise.resolve();
    }
    if (!turnstileScriptPromise) {
        turnstileScriptPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = TURNSTILE_SCRIPT_URL;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error('Failed to load Turnstile script'));
            document.head.appendChild(script);
        });
    }
    return turnstileScriptPromise;
};
const defaultFormState = {
    first: '',
    last: '',
    email: '',
    message: '',
};
const ContactForm = () => {
    const [formState, setFormState] = (0, react_1.useState)(defaultFormState);
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const [status, setStatus] = (0, react_1.useState)('idle');
    const [error, setError] = (0, react_1.useState)(null);
    const [isLoadingCaptcha, setIsLoadingCaptcha] = (0, react_1.useState)(true);
    const [turnstileSiteKey, setTurnstileSiteKey] = (0, react_1.useState)('');
    const [captchaToken, setCaptchaToken] = (0, react_1.useState)('');
    const [captchaReady, setCaptchaReady] = (0, react_1.useState)(false);
    const [captchaError, setCaptchaError] = (0, react_1.useState)(null);
    const turnstileContainerRef = (0, react_1.useRef)(null);
    const turnstileWidgetIdRef = (0, react_1.useRef)(null);
    const runtimeConfig = (0, runtime_config_1.getRuntimeConfig)();
    const backendBasePath = (0, react_1.useMemo)(() => {
        var _a, _b;
        return (_b = (_a = runtimeConfig === null || runtimeConfig === void 0 ? void 0 : runtimeConfig.backendBasePath) !== null && _a !== void 0 ? _a : runtimeConfig === null || runtimeConfig === void 0 ? void 0 : runtimeConfig.basePath) !== null && _b !== void 0 ? _b : '';
    }, [runtimeConfig]);
    const apiBase = (0, react_1.useMemo)(() => {
        if (!backendBasePath) {
            return '';
        }
        return backendBasePath.endsWith('/') ? backendBasePath.slice(0, -1) : backendBasePath;
    }, [backendBasePath]);
    const contactEndpoint = (0, react_1.useMemo)(() => {
        return `${apiBase}/api/v1/contact`;
    }, [apiBase]);
    const captchaConfigEndpoint = (0, react_1.useMemo)(() => {
        return `${apiBase}/api/v1/contact/captcha`;
    }, [apiBase]);
    (0, react_1.useEffect)(() => {
        let cancelled = false;
        const loadSiteKey = async () => {
            var _a, _b;
            setIsLoadingCaptcha(true);
            setCaptchaError(null);
            try {
                const response = await fetch(captchaConfigEndpoint);
                const payload = await response.json().catch(() => ({}));
                if (!response.ok) {
                    const message = (_a = payload.error) !== null && _a !== void 0 ? _a : 'Unable to load captcha.';
                    throw new Error(message);
                }
                const resolvedSiteKey = (_b = payload.siteKey) !== null && _b !== void 0 ? _b : '';
                if (!cancelled) {
                    setTurnstileSiteKey(resolvedSiteKey);
                    if (!resolvedSiteKey) {
                        setCaptchaError('Captcha is not configured.');
                    }
                }
            }
            catch (siteKeyError) {
                console.error(siteKeyError);
                if (!cancelled) {
                    setCaptchaError('Unable to load captcha configuration.');
                }
            }
            finally {
                if (!cancelled) {
                    setIsLoadingCaptcha(false);
                }
            }
        };
        loadSiteKey();
        return () => {
            cancelled = true;
        };
    }, [captchaConfigEndpoint]);
    (0, react_1.useEffect)(() => {
        if (!turnstileSiteKey) {
            setCaptchaReady(false);
            return;
        }
        let cancelled = false;
        loadTurnstileScript()
            .then(() => {
            if (!cancelled) {
                setCaptchaReady(true);
            }
        })
            .catch((loadError) => {
            console.error(loadError);
            if (!cancelled) {
                setCaptchaError('Captcha failed to load. Please refresh and try again.');
            }
        });
        return () => {
            cancelled = true;
            if (turnstileWidgetIdRef.current && window.turnstile) {
                window.turnstile.remove(turnstileWidgetIdRef.current);
                turnstileWidgetIdRef.current = null;
            }
        };
    }, [turnstileSiteKey]);
    (0, react_1.useEffect)(() => {
        if (!captchaReady || !turnstileSiteKey) {
            return;
        }
        if (!turnstileContainerRef.current || !window.turnstile) {
            return;
        }
        if (turnstileWidgetIdRef.current) {
            return;
        }
        turnstileWidgetIdRef.current = window.turnstile.render(turnstileContainerRef.current, {
            sitekey: turnstileSiteKey,
            theme: 'light',
            callback: (token) => {
                setCaptchaToken(token);
                setCaptchaError(null);
            },
            'expired-callback': () => {
                setCaptchaToken('');
            },
            'error-callback': () => {
                setCaptchaToken('');
                setCaptchaError('Captcha error, please try again.');
            },
        });
    }, [captchaReady, turnstileSiteKey]);
    const handleChange = (field) => (event) => {
        setFormState((prev) => (Object.assign(Object.assign({}, prev), { [field]: event.target.value })));
    };
    const handleSubmit = async (event) => {
        var _a;
        event.preventDefault();
        setError(null);
        setStatus('idle');
        if (!turnstileSiteKey || isLoadingCaptcha) {
            setStatus('error');
            setError(isLoadingCaptcha ? 'Captcha is still loading. Please try again.' : 'Captcha is not configured. Please try again later.');
            return;
        }
        if (!captchaToken) {
            setStatus('error');
            setError('Please complete the captcha challenge.');
            return;
        }
        setIsSubmitting(true);
        try {
            const response = await fetch(contactEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(Object.assign(Object.assign({}, formState), { captchaToken })),
            });
            const result = await response.json().catch(() => ({}));
            if (!response.ok) {
                const message = (_a = result.error) !== null && _a !== void 0 ? _a : 'Unable to submit your message right now.';
                throw new Error(message);
            }
            setStatus('success');
            setFormState(defaultFormState);
        }
        catch (submitError) {
            console.error(submitError);
            setStatus('error');
            if (submitError instanceof Error) {
                setError(submitError.message);
            }
            else {
                setError('Unable to submit your message right now.');
            }
        }
        finally {
            setIsSubmitting(false);
            setCaptchaToken('');
            if (window.turnstile && turnstileWidgetIdRef.current) {
                window.turnstile.reset(turnstileWidgetIdRef.current);
            }
        }
    };
    return (react_1.default.createElement("section", { id: "contact", className: "mx-auto max-w-5xl px-6 sm:px-10 lg:px-12" },
        react_1.default.createElement("div", { className: "flex flex-col gap-4 text-center" },
            react_1.default.createElement(badge_1.Badge, { variant: "outline", className: "mx-auto px-3 py-1 text-xs uppercase tracking-wide" }, "Contact"),
            react_1.default.createElement("h2", { className: "text-3xl font-semibold sm:text-4xl" }, "Tell us what you're building."),
            react_1.default.createElement("p", { className: "text-base text-muted-foreground sm:text-lg" }, "Share your details and we'll get back with implementation guidance, pricing clarity, or a live walkthrough.")),
        react_1.default.createElement(card_1.Card, { className: "mt-8 border-border/70 bg-card/80" },
            react_1.default.createElement(card_1.CardHeader, { className: "space-y-2" },
                react_1.default.createElement(card_1.CardTitle, { className: "flex items-center gap-2 text-lg sm:text-xl" },
                    react_1.default.createElement(lucide_react_1.ShieldCheck, { className: "h-5 w-5 text-primary" }),
                    "Reach the Authlance team")),
            react_1.default.createElement(card_1.CardContent, null,
                react_1.default.createElement("form", { className: "space-y-6", onSubmit: handleSubmit },
                    react_1.default.createElement("div", { className: "grid gap-4 sm:grid-cols-2" },
                        react_1.default.createElement("div", { className: "space-y-2" },
                            react_1.default.createElement(label_1.Label, { htmlFor: "first" }, "First name"),
                            react_1.default.createElement(input_1.Input, { id: "first", name: "first", autoComplete: "given-name", required: true, value: formState.first, onChange: handleChange('first') })),
                        react_1.default.createElement("div", { className: "space-y-2" },
                            react_1.default.createElement(label_1.Label, { htmlFor: "last" }, "Last name"),
                            react_1.default.createElement(input_1.Input, { id: "last", name: "last", autoComplete: "family-name", required: true, value: formState.last, onChange: handleChange('last') })),
                        react_1.default.createElement("div", { className: "space-y-2 sm:col-span-2" },
                            react_1.default.createElement(label_1.Label, { htmlFor: "email" }, "Work email"),
                            react_1.default.createElement(input_1.Input, { id: "email", name: "email", type: "email", autoComplete: "email", required: true, value: formState.email, onChange: handleChange('email') }))),
                    react_1.default.createElement("div", { className: "space-y-2" },
                        react_1.default.createElement(label_1.Label, { htmlFor: "message" }, "What can we help with?"),
                        react_1.default.createElement(textarea_1.Textarea, { id: "message", name: "message", rows: 4, required: true, value: formState.message, onChange: handleChange('message'), placeholder: "Share your thoughts." })),
                    react_1.default.createElement("div", { className: "space-y-3" },
                        react_1.default.createElement(label_1.Label, null, "Captcha"),
                        react_1.default.createElement("div", { className: "rounded-lg border border-border/70 bg-muted/30 p-3" }, isLoadingCaptcha ? (react_1.default.createElement("p", { className: "flex items-center gap-2 text-sm text-muted-foreground" },
                            react_1.default.createElement(lucide_react_1.Loader2, { className: "h-4 w-4 animate-spin" }),
                            "Loading captcha challenge...")) : !turnstileSiteKey ? (react_1.default.createElement("p", { className: "text-sm text-destructive" }, "Captcha is not configured. Please contact support.")) : (react_1.default.createElement("div", { ref: turnstileContainerRef, className: "min-h-[80px]" }))),
                        captchaError && (react_1.default.createElement("p", { className: "text-sm text-destructive flex items-center gap-2" },
                            react_1.default.createElement(lucide_react_1.AlertCircle, { className: "h-4 w-4" }),
                            captchaError))),
                    react_1.default.createElement("div", { className: "flex flex-col gap-3 sm:flex-row sm:items-center" },
                        react_1.default.createElement(button_1.Button, { type: "submit", size: "lg", disabled: isSubmitting || !turnstileSiteKey || isLoadingCaptcha },
                            isSubmitting && react_1.default.createElement(lucide_react_1.Loader2, { className: "mr-2 h-4 w-4 animate-spin" }),
                            "Send message"),
                        status === 'success' && (react_1.default.createElement("span", { className: "inline-flex items-center gap-2 text-sm text-primary" },
                            react_1.default.createElement(lucide_react_1.CheckCircle2, { className: "h-4 w-4" }),
                            "Message sent. We'll reply shortly.")),
                        status === 'error' && error && (react_1.default.createElement("span", { className: "inline-flex items-center gap-2 text-sm text-destructive" },
                            react_1.default.createElement(lucide_react_1.AlertCircle, { className: "h-4 w-4" }),
                            error))))))));
};
exports.ContactForm = ContactForm;
exports.default = exports.ContactForm;
